<div class="bg-azulOscuro">


    <!-- <div class="bg-center pt-5 flex items-center justify-center animate__animated animate__fadeIn animate__delay-1s">
    <img *ngIf="isDarkMode === false" src="../../../../assets/images/logo-26.png" alt="img" class=" w-40 flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s">
    <img *ngIf="isDarkMode === true" src="../../../../assets/images/logo-26.png" alt="img" class=" w-40 flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s">
    </div> -->
    <div class="pt-2">

        <div class="mb-5 flex overflow-y-auto whitespace-nowrap border-b text-white border-white font-semibold animate__animated animate__slideInRight animate__delay-1s">

            <a
                (click)="goBack()"
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-azulOscuro hover:text-primary"
            >
                <icon-arrow-backward />
                Volver
            </a>

            <a
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-azulOscuro hover:text-primary"
                [ngClass]="{ '!border-white text-white':  activeTab.toLowerCase() === 'home'}"
                (click)="activeTab = 'home'"
            >
                <icon-user-plus />
                {{ 'EDIT-PROFILE.START' | translate }}
            </a>

        </div>
        <!-- End Navs -->
        <div>
            <div *ngIf="activeTab.toLowerCase() === 'home'">
                <app-home-profile></app-home-profile>
            </div>

        </div>
    </div>
</div>
